export default 'accident';
